(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["farana-collection-grid"]) return;
  try {
    
function initFaranaCatalog(){document.querySelectorAll('[data-farana-catalog]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const grid=root.querySelector('[data-grid]'),items=[...grid.querySelectorAll('[data-item]')],color=root.querySelector('[data-color]'),format=root.querySelector('[data-format]'),stock=root.querySelector('[data-stock]'),sort=root.querySelector('[data-sort]'),msg=JSON.parse(root.querySelector('[data-filter-messages]').textContent);for(const [select,key] of [[color,'color'],[format,'format']]){[...new Set(items.map(i=>i.dataset[key]).filter(Boolean))].sort((a,b)=>a.localeCompare(b,'fr')).forEach(value=>{const o=document.createElement('option');o.value=value;o.textContent=value.charAt(0).toUpperCase()+value.slice(1);select.append(o)})}function update(){let count=0;items.forEach(i=>{i.hidden=!!((color.value&&i.dataset.color!==color.value)||(format.value&&i.dataset.format!==format.value)||(stock.value&&i.dataset.available!=='true'));if(!i.hidden)count++});[...items].sort((a,b)=>sort.value==='price-up'?Number(a.dataset.price)-Number(b.dataset.price):sort.value==='price-down'?Number(b.dataset.price)-Number(a.dataset.price):Number(a.dataset.index)-Number(b.dataset.index)).forEach(i=>grid.append(i));root.querySelector('[data-count]').textContent=count+' '+msg.count;root.querySelector('[data-empty]').hidden=count!==0}root.querySelector('form').addEventListener('change',update);root.querySelector('form').addEventListener('reset',()=>requestAnimationFrame(update));update()})}initFaranaCatalog();document.addEventListener('shopify:section:load',initFaranaCatalog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["farana-duo-builder"] && !Shopify.designMode) return;
  try {
    
function initFaranaBuilders(){document.querySelectorAll('[data-farana-builder]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const data=JSON.parse(root.querySelector('[data-products]').textContent),msg=JSON.parse(root.querySelector('[data-messages]').textContent),form=root.querySelector('form'),family=root.querySelector('[data-family]'),people=[...root.querySelectorAll('[data-person]')],submit=root.querySelector('[data-submit]'),status=root.querySelector('[data-status]');let busy=false;const money=n=>new Intl.NumberFormat(document.documentElement.lang||'fr',{style:'currency',currency:root.dataset.currency}).format(n/100);const option=(value,text,disabled=false)=>{const o=document.createElement('option');o.value=value;o.textContent=text;o.disabled=disabled;return o};const groups=()=>family.value==='bags'?['banane','sac-banane-enfant']:['gilets-adultes','vetements'];const model=p=>data.find(x=>String(x.id)===p.querySelector('[data-product]').value&&x.group===groups()[people.indexOf(p)]);const chosen=p=>model(p)?.variants.find(v=>String(v.id)===p.querySelector('[data-variant]').value);function update(){const selected=people.map(chosen),valid=selected.every(v=>v?.available);submit.disabled=busy||!valid;root.querySelector('[data-total]').textContent=valid?money(Math.max(0,selected.reduce((s,v)=>s+v.price,0)-Number(family.value==='vests'?root.dataset.vestDiscount:root.dataset.discount))):'—';const original=root.querySelector('[data-original]');original.hidden=!valid;original.textContent=valid?money(selected.reduce((s,v)=>s+v.price,0)):'';people.forEach((p,i)=>{p.querySelector('[data-price]').textContent=selected[i]?money(selected[i].price):''})}function changeProduct(p){const product=model(p),variants=p.querySelector('[data-variant]'),img=p.querySelector('[data-image]'),link=p.querySelector('[data-detail]');variants.replaceChildren(option('',msg.choose));if(product){product.variants.filter(v=>people.indexOf(p)!==0||!v.title.toLowerCase().includes('enfant')).forEach(v=>variants.append(option(v.id,(v.title==='Default Title'?msg.single:v.title)+(v.available?'':' — '+msg.sold),!v.available)));img.hidden=!product.image;if(product.image){img.src=product.image;img.alt=product.title}link.href=product.url;link.hidden=false}else{img.hidden=true;link.hidden=true}update()}function reset(){people.forEach((p,i)=>{const select=p.querySelector('[data-product]');select.replaceChildren(option('',msg.choose));data.filter(x=>x.group===groups()[i]).forEach(x=>select.append(option(x.id,x.title)));changeProduct(p)});status.textContent='';root.querySelector('[data-cart]').hidden=true}people.forEach(p=>{p.querySelector('[data-product]').addEventListener('change',()=>changeProduct(p));p.querySelector('[data-variant]').addEventListener('change',update)});family.addEventListener('change',reset);form.addEventListener('submit',async event=>{event.preventDefault();if(busy)return;const selected=people.map(chosen);if(!selected.every(v=>v?.available))return;busy=true;update();status.textContent=msg.busy;try{const response=await fetch(root.dataset.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:selected.map(v=>({id:v.id,quantity:1}))})});const result=await response.json();if(!response.ok)throw new Error(typeof result.description==='string'?result.description:msg.error);status.textContent=msg.added;root.querySelector('[data-cart]').hidden=false;form.reset();reset();status.textContent=msg.added;root.querySelector('[data-cart]').hidden=false}catch(error){status.textContent=error.message||msg.error}finally{busy=false;update()}});reset()})}initFaranaBuilders();document.addEventListener('shopify:section:load',initFaranaBuilders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  const images = document.querySelectorAll('.mw-image-gallery a');
  const modal = document.querySelector('.mw-modal');
  const modalImage = modal.querySelector('img');
  let currentIndex = 0;
  
  // Open modal popup and show clicked image
  function showModal(index) {
    if(window.innerWidth > 749){
      modalImage.src = images[index].dataset.desktop;
    } else {
      modalImage.src = images[index].dataset.mobile;  
    }    
    modal.classList.add('show');
    currentIndex = index;
  }
  
  // Hide modal popup
  function hideModal() {
    modal.classList.remove('show');
  }
  
  // Show previous image in gallery
  function showPrevImage(e) {
    e.stopPropagation()
    if (currentIndex === 0) {
      showModal(images.length - 1);
    } else {
      showModal(currentIndex - 1);
    }
  }
  
  // Show next image in gallery
  function showNextImage(e) {
    e.stopPropagation()
    if (currentIndex === images.length - 1) {
      showModal(0);
    } else {
      showModal(currentIndex + 1);
    }
  }
  
  // Add click event listeners to all images
  images.forEach((image, index) => {
    image.addEventListener('click', (e) => {
      e.preventDefault()
      showModal(index);
    });
  });  
    
  // Add click event listeners to modal navigation arrows
  const prevArrow = modal.querySelector('.mw-modal-prev');
  prevArrow.addEventListener('click', showPrevImage);
  
  const nextArrow = modal.querySelector('.mw-modal-next');
  nextArrow.addEventListener('click', showNextImage);
  
  // Add click event listener to modal background to hide it
  modal.addEventListener('click', hideModal);

  
})()

  } catch(e) { console.error(e); }
})();
})();
